<template>
  <div class="spinner" :style="{ backgroundColor: bgc }">
    <img src="@/assets/img/loading-red.svg" />
    <div class="text">loading..</div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    bgc: {
      type: String,
      default: '#ffffff',
    },
  },
}
</script>

<style scoped>
.spinner {
  text-align: center;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner > img {
  width: 38px;
  height: 38px;
  object-fit: contain;
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  filter: grayscale(1);
}

.text {
  font-size: 12px;
  color: #9b9b9b;
  margin-top: 6px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
